/**
 * Patent相关的API接口定义
 */
export const PatentApi = Symbol('PatentApi');
